import * as React from 'react';
import { PreferenceKey, Preferences } from './type';

const PreferenceContext = React.createContext<PreferenceContextType | undefined>(undefined);

interface PreferenceContextType {
    preferences: Preferences | null;
    set: (key: PreferenceKey, value: string | null) => void;
    get: (key: PreferenceKey) => string | null;
}

export const PreferenceProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [preferences, setPreferences] = React.useState<Preferences | null>(null);

    // init
    React.useEffect(() => {
        const preferences: Preferences = {
            [PreferenceKey.Username]: localStorage.getItem(PreferenceKey.Username),
            [PreferenceKey.School]: localStorage.getItem(PreferenceKey.School),
        };

        setPreferences(preferences);
    }, []);

    const get = React.useCallback((key: PreferenceKey): string | null => {
        return localStorage.getItem(key);
    }, []);

    const set = React.useCallback((key: PreferenceKey, value: string | null) => {
        if (value === null) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, value);
        }

        setPreferences(
            (prev) =>
                ({
                    ...prev,
                    [key]: value,
                }) as Preferences,
        );
    }, []);

    if (preferences === null) {
        return null;
    }

    return (
        <PreferenceContext.Provider
            value={{
                preferences,
                set,
                get,
            }}
        >
            {children}
        </PreferenceContext.Provider>
    );
};

export const usePreference = (): PreferenceContextType => {
    const context = React.useContext(PreferenceContext);
    if (!context) {
        throw new Error('usePreferecne must be used within a PreferenceProvider');
    }

    return context;
};
